<template>
      <div ref="elementLeftMenu" class="a-vs-c--left-menu a-vs-b--top-nav">
        <div :class="{'a-vs-b--overlay': isOverlayShow}" ref="overlay" @click="toggleLeftMenu"></div>
        <app-header
          class="a-vs-b--visible-bar"
          :logoClass="'a-vs-c-logo'"
          :amount="amount"
          :currency="currency"
          :isSoccer="true"
          @onToggleLeftMenu="toggleLeftMenu" />

        <div class="wrapper">
         <transition name="slide">
            <div v-if="showLeftMenu" class="a-vs-b-menu-wrap">
              <div class="a-vs-b-menu-wrap--header">
                <!-- Mobile logo container -->
                <mobile-side-menu-header
                  class="a-vs-b--mobile-logo"
                  :isSoccer="true"
                  @onToggleLeftMenu="toggleLeftMenu"/>

                <!-- User profile container -->
                <user-profile
                  :userName="userName"
                  :userEmail="userEmail"/>
              </div>
              <!-- Collapsing container -->
              <div class="a-vs-b-menu-wrap--body">
                <ul class="nav-links">
                  <change-languages />
                  <li @click="showBettingHistoryFunction()">
                    <div>
                      <image-svg :imageClass="'a-vs-icon'" :imageName="'betting-history'"/>
                      <span>{{$t('betting_history')}}</span>
                    </div>
                  </li>
                  <li @click="toggleAudio()">
                  <div>
                    <image-svg style="padding-left: 8px;" :imageClass="'a-vs-icon'" :imageName="hasAudioEnabled ? 'volume-down' : 'volume-up'"/>
										<span>{{ hasAudioEnabled ? $t('disable_audio') : $t('enable_audio') }}</span>
									</div>
                  </li>
                </ul>
              </div>
          </div>
        </transition>
      </div>
    </div>
</template>
<script>
import { eventBus } from '@/main.js'
import EventConstants from '@/constants/Events'
import MobileDevice from '@/mixins/MobileDevice'
import { store } from '@/store/store.js'
import AppHeader from '@/components/common/AppHeader.vue'
import UserProfile from '@/components/common/UserProfile.vue'
import MobileSideMenuHeader from '@/components/common/MobileSideMenuHeader.vue'
import ChangeLanguages from '@/components/common/ChangeLanguages.vue'
import ImageSVG from '@/components/common/ImageSVG.vue'
import vuexStore from '../../../store/vuexStore'

export default {
  components: {
    'user-profile': UserProfile,
    'mobile-side-menu-header': MobileSideMenuHeader,
    'change-languages': ChangeLanguages,
    'image-svg': ImageSVG,
    'app-header': AppHeader
  },
  mixins: [MobileDevice],
  props: {
    showLeftMenu: Boolean,
    currency: {
      type: String,
      required: true
    },
    amount: {
      type: Number,
      required: true
    },
    showBettingHistory: {
      type: Boolean,
      requred: true
    }
  },
  data () {
    return {
      isOpen: false,
      isOverlayShow: false,
      hasAudioEnabled: vuexStore.state.hasAudioEnabled
    }
  },
  mounted: function () {
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
  },
  computed: {
    userName: function () {
      return store.getUsername()
    },
    userEmail: function () {
      return store.getEmail()
    },
    overlay: function () {
      return this.$refs.overlay
    }
  },
  methods: {
    onEventSwipe: function (value) {
      this.isOpen = false
    },
    toggleLeftMenu () {
      eventBus.onConfirmModalResetStake()
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        if (this.isMobileDevice()) {
          this.isOverlayShow = true
          eventBus.onGameScrollLock('true')
        }
      } else {
        if (!this.showBettingHistory || !this.isMobileDevice()) {
          eventBus.onGameScrollUnock('true')
        }
        this.isOverlayShow = false
      }
      eventBus.toggleLeftMenu(this.isOpen)
    },
    showBettingHistoryFunction: function () {
      eventBus.showBettingHistory(true)
      this.toggleLeftMenu()
    },
    toggleAudio () {
      vuexStore.dispatch('setAudio')
    }
  },
  created: function () {
    eventBus.$on(EventConstants.CHANGE_GAME_ACTION, this.onEventSwipe)
  },
  beforeDestroy () {
    eventBus.$off(EventConstants.CHANGE_GAME_ACTION, this.onEventSwipe)
  }
}
</script>
